import actionTypes from '../constants/action-types';

const updateCustomFontPair = (fontPair) => ({
  type: actionTypes.UPDATE_CUSTOM_FONT_PAIR,
  payload: {
    fontPair,
  },
});

export default updateCustomFontPair;
